import React, { useState } from "react";
import { Modal, Form, Button, Row, Col } from "react-bootstrap";
import Select from "react-select";
import "./WorkExperienceModal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";

const WorkExperienceModal = ({ show, handleClose }) => {
  // --- Form Functional States ---
  const jobTitleOptions = [
    { value: "frontend", label: "Frontend Development Engineer" },
    { value: "backend", label: "Backend Developer" },
    { value: "fullstack", label: "Full Stack Developer" },
    { value: "react", label: "React Developer" },
    { value: "uiux", label: "UI/UX Designer" },
    { value: "qa", label: "QA Engineer" },
    { value: "devops", label: "DevOps Engineer" },
  ];

  const [jobTitle, setJobTitle] = useState(jobTitleOptions[0]);
  const [company, setCompany] = useState({ value: "other", label: "Other" });
  const [customCompany, setCustomCompany] = useState(
    "Profcyma Global Solutions",
  );
  const [startYear, setStartYear] = useState("2023");
  const [startMonth, setStartMonth] = useState("June");
  const [currentlyWorking, setCurrentlyWorking] = useState(true);
  const [salary, setSalary] = useState("3,20,000");
  const [noticePeriod, setNoticePeriod] = useState("15 days");
  const [industry, setIndustry] = useState(null);
  const [employmentType, setEmploymentType] = useState(null);
  const [description, setDescription] = useState(
    "Developed and launched 5+ dynamic, high-traffic websites using React, HTML, CSS, and Bootstrap, leading to a 25% increase in user engagement and a 15% reduction in bounce rates.",
  );

  // --- Dropdown Options ---
  const companyOptions = [
    { value: "profcyma", label: "Profcyma Global Solutions" },
    { value: "pratian", label: "Pratian Technologies" },
    { value: "other", label: "Other" },
  ];

  const industryOptions = [
    { value: "it", label: "IT Services and IT Consulting" },
    { value: "software", label: "Software Development" },
    { value: "edtech", label: "E-Learning Providers" },
  ];

  const employmentOptions = [
    { value: "fulltime", label: "Full-time" },
    { value: "parttime", label: "Part-time" },
    { value: "contract", label: "Contract" },
    { value: "internship", label: "Internship" },
  ];

  // React-Select Custom Styling to match your interface
  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#9b51e0" : "#dcdde1",
      boxShadow: "none",
      "&:hover": { borderColor: state.isFocused ? "#9b51e0" : "#c8d6e5" },
      fontSize: "15px",
      minHeight: "38px",
      borderRadius: "4px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#9b51e0"
        : state.isFocused
          ? "#f3e8ff"
          : "#fff",
      color: state.isSelected ? "#fff" : "#2f3542",
      fontSize: "14px",
    }),
  };

  const handleSaveSubmit = (e) => {
    e.preventDefault();
    console.log("Saving Work Experience Data:", {
      jobTitle,
      company: company.value === "other" ? customCompany : company.label,
      startYear,
      startMonth,
      currentlyWorking,
      salary,
      noticePeriod,
      industry: industry?.label,
      employmentType: employmentType?.label,
      description,
    });
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      scrollable
      size="lg"
      dialogClassName="common-modal work-experience-modal"
    >
      <Modal.Header className="we-modal-header d-flex align-items-center">
        <Modal.Title className="we-modal-title">
          {" "}
          <Button
            variant="link"
            className="we-back-btn p-0 me-2"
            onClick={handleClose}
          >
            <FontAwesomeIcon icon={faAngleLeft} />
          </Button>{" "}
          Work experience
        </Modal.Title>
        <button
          type="button"
          className="btn-close ms-auto"
          onClick={handleClose}
          aria-label="Close"
        ></button>
      </Modal.Header>

      <Modal.Body className="we-modal-body">
        <Form onSubmit={handleSaveSubmit}>
          {/* Job Title */}
          <Form.Group className="mb-3">
            <Form.Label className="we-form-label">
              Job Title <span className="text-danger">*</span>
            </Form.Label>

            <Select
              options={jobTitleOptions}
              value={jobTitle}
              onChange={setJobTitle}
              styles={customSelectStyles}
              placeholder="Select Job Title"
              isSearchable
              isClearable
            />
          </Form.Group>

          {/* Company Dropdown */}
          <Form.Group className="mb-3">
            <Form.Label className="we-form-label">
              Company <span className="text-danger">*</span>
            </Form.Label>
            <Select
              options={companyOptions}
              value={company}
              onChange={setCompany}
              styles={customSelectStyles}
            />
          </Form.Group>

          {/* Conditional Custom Company Input Field */}
          {company?.value === "other" && (
            <Form.Group className="mb-3">
              <Form.Label className="we-form-label">
                Enter Your Company <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                className="we-form-input"
                type="text"
                value={customCompany}
                onChange={(e) => setCustomCompany(e.target.value)}
                required
              />
            </Form.Group>
          )}

          {/* Start Date Selection Panel Row */}
          <Form.Group className="mb-3">
            <Form.Label className="we-form-label">
              Start Date <span className="text-danger">*</span>
            </Form.Label>
            <Row>
              <Col>
                <Form.Select
                  className="we-form-select"
                  value={startYear}
                  onChange={(e) => setStartYear(e.target.value)}
                >
                  <option value="2026">2026</option>
                  <option value="2025">2025</option>
                  <option value="2024">2024</option>
                  <option value="2023">2023</option>
                  <option value="2022">2022</option>
                </Form.Select>
              </Col>
              <Col>
                <Form.Select
                  className="we-form-select"
                  value={startMonth}
                  onChange={(e) => setStartMonth(e.target.value)}
                >
                  <option value="January">January</option>
                  <option value="February">February</option>
                  <option value="May">May</option>
                  <option value="June">June</option>
                </Form.Select>
              </Col>
            </Row>
          </Form.Group>

          {/* Checkbox Toggle Item */}
          <Form.Group className="mb-4 d-flex align-items-center">
            <Form.Check
              type="checkbox"
              id="currently-working-checkbox"
              className="we-custom-checkbox"
              checked={currentlyWorking}
              onChange={(e) => setCurrentlyWorking(e.target.checked)}
              label="Currently working here"
            />
          </Form.Group>

          {/* Salary Metric Input Fields */}
          <Form.Group className="mb-3">
            <Form.Label className="we-form-label">
              Current Salary (Annually) <span className="text-danger">*</span>
            </Form.Label>
            <div className="we-salary-input-group d-flex align-items-center">
              <Form.Select className="we-currency-select border-end-0 rounded-start">
                <option>🇮🇳 INR</option>
                <option>🇺🇸 USD</option>
              </Form.Select>
              <Form.Control
                className="we-salary-control rounded-end"
                type="text"
                value={salary}
                onChange={(e) => setSalary(e.target.value)}
              />
            </div>
            <div className="we-salary-helper text-muted mt-1">
              INR Three Lakh Twenty Thousand{" "}
              <span className="fw-semibold">(Annually)</span>
            </div>
          </Form.Group>

          {/* Notice Period Selection List Dropdowns */}
          <Form.Group className="mb-3">
            <Form.Label className="we-form-label">
              Notice Period <span className="text-danger">*</span>
            </Form.Label>
            <Form.Select
              className="we-form-select"
              value={noticePeriod}
              onChange={(e) => setNoticePeriod(e.target.value)}
            >
              <option value="Immediate">Immediate</option>
              <option value="15 days">15 days</option>
              <option value="1 Month">1 Month</option>
              <option value="2 Months">2 Months</option>
            </Form.Select>
          </Form.Group>

          {/* Industry Search Dynamic Dropdowns */}
          <Form.Group className="mb-3">
            <Form.Label className="we-form-label">Industry</Form.Label>
            <Select
              options={industryOptions}
              value={industry}
              onChange={setIndustry}
              styles={customSelectStyles}
              placeholder="Enter or select your Industry"
              isClearable
            />
          </Form.Group>

          {/* Employment Type */}
          <Form.Group className="mb-3">
            <Form.Label className="we-form-label">Employment Type</Form.Label>
            <Select
              options={employmentOptions}
              value={employmentType}
              onChange={setEmploymentType}
              styles={customSelectStyles}
              placeholder="Select Employment Type"
              isClearable
            />
          </Form.Group>

          {/* Job Task Descriptions */}
          <Form.Group className="mb-3">
            <Form.Label className="we-form-label">Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              className="we-textarea"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer className="we-modal-footer">
        <Button
          variant="primary"
          className="we-btn-save"
          onClick={handleSaveSubmit}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default WorkExperienceModal;
